import { useEffect } from 'react';
import iconNoPermission from './../../../assets/ei_kayttooikeutta.png';
import {
  AnalyticsPhaseCategories,
  AnalyticsPhases,
  trackPhase,
} from 'api/analytics-api';
import i18n from 'i18n';
import { ErrorPage } from 'individual/components/ErrorPage';

export default function ProfilingBlock() {
  useEffect(() => {
    trackPhase(
      AnalyticsPhaseCategories.STEP,
      AnalyticsPhases.RESTRICTED_ACCESS
    );
  }, []);
  return (
    <ErrorPage
      componentId='lifepurchase-profiling-block'
      headerText={i18n.t('error.restrictedAccess')}
      errorMessageText={i18n.t('error.profilingBlock')}
      image={iconNoPermission}
    />
  );
}
